import React, { useState, useRef } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Save, Building2, FileText } from "lucide-react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const GenerateBill = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const billRef = useRef(null);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const downloadPDF = async () => {
    const input = billRef.current;

    const canvas = await html2canvas(input, {
      scale: 2,
    });

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight =
      (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("Society_Maintenance_Bill.pdf");
  };

  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />

      <div className="main-layout">
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />

        <main className="content-area">
          <SubHeader />

          <div className="p-6">
            {/* Download Button */}
            <div className="flex justify-end mb-4">
              <button
                onClick={downloadPDF}
                className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-lg shadow-md"
              >
                <Save size={18} />
                Download PDF
              </button>
            </div>

            {/* Bill */}
            <div
              ref={billRef}
              className="bg-white max-w-5xl mx-auto p-8 shadow-xl border rounded-lg"
            >
              {/* Header */}
              <div className="flex justify-between items-start border-b pb-5">
                <div>
                  <h1 className="text-3xl font-bold text-gray-800">
                    SOCIETY MAINTENANCE BILL
                  </h1>

                  <p className="text-gray-500">
                    Bill No: SMB-2026-001
                  </p>

                  <p className="text-gray-500">
                    Date: 30 May 2026
                  </p>

                  <p className="text-gray-500">
                    Billing Month: May 2026
                  </p>
                </div>

                <div className="text-right">
                  <Building2 className="w-10 h-10 text-green-600 ml-auto" />

                  <h2 className="font-bold text-xl">
                    Green View Co-op Housing Society
                  </h2>

                  <p>Andheri East, Mumbai</p>

                  <p>Reg No: MUM/SOC/12345/2020</p>

                  <p>contact@greenviewsociety.com</p>
                </div>
              </div>

              {/* Member Details */}
              <div className="grid grid-cols-2 gap-8 mt-6">
                <div>
                  <h3 className="font-semibold text-lg mb-2">
                    Member Details
                  </h3>

                  <p className="font-medium">
                    Mr. Rajesh Sharma
                  </p>

                  <p>Flat No: B-402</p>

                  <p>Wing: B</p>

                  <p>Mobile: 9876543210</p>
                </div>

                <div className="text-right">
                  <h3 className="font-semibold text-lg mb-2">
                    Payment Details
                  </h3>

                  <p>Due Date: 10 June 2026</p>

                  <p>Status: Unpaid</p>

                  <p>Mode: Online / Cheque</p>
                </div>
              </div>

              {/* Charges Table */}
              <div className="mt-8">
                <table className="w-full border-collapse border border-gray-300">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border p-3 text-left">
                        Particulars
                      </th>

                      <th className="border p-3 text-center">
                        Amount (₹)
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td className="border p-3">
                        Maintenance Charges
                      </td>
                      <td className="border p-3 text-center">
                        2,500
                      </td>
                    </tr>

                    <tr>
                      <td className="border p-3">
                        Sinking Fund
                      </td>
                      <td className="border p-3 text-center">
                        500
                      </td>
                    </tr>

                    <tr>
                      <td className="border p-3">
                        Water Charges
                      </td>
                      <td className="border p-3 text-center">
                        700
                      </td>
                    </tr>

                    <tr>
                      <td className="border p-3">
                        Lift Maintenance
                      </td>
                      <td className="border p-3 text-center">
                        400
                      </td>
                    </tr>

                    <tr>
                      <td className="border p-3">
                        Security Charges
                      </td>
                      <td className="border p-3 text-center">
                        900
                      </td>
                    </tr>

                    <tr>
                      <td className="border p-3">
                        Parking Charges
                      </td>
                      <td className="border p-3 text-center">
                        500
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Summary */}
              <div className="flex justify-end mt-8">
                <div className="w-80">
                  <div className="flex justify-between py-2">
                    <span>Total Charges</span>
                    <span>₹5,500</span>
                  </div>

                  <div className="border-t mt-2 pt-3 flex justify-between text-xl font-bold">
                    <span>Grand Total</span>
                    <span>₹5,500</span>
                  </div>
                </div>
              </div>

              {/* Notes */}
              <div className="mt-10 border-t pt-5">
                <div className="flex items-center gap-2 mb-2">
                  <FileText size={18} />

                  <h3 className="font-semibold">
                    Terms & Conditions
                  </h3>
                </div>

                <ul className="text-sm text-gray-600 space-y-1">
                  <li>
                    • Please pay maintenance charges before the due date.
                  </li>

                  <li>
                    • Delay in payment may attract penalty charges.
                  </li>

                  <li>
                    • Keep payment receipt for future reference.
                  </li>

                  <li>
                    • This is a computer-generated bill.
                  </li>
                </ul>
              </div>

              {/* Footer */}
              <div className="mt-12 text-center text-gray-500 text-sm">
                Thank you for being a valued member of our society.
              </div>
            </div>
          </div>

          <ToastContainer />
        </main>
      </div>
    </div>
  );
};

export default GenerateBill;